import useSWR from 'swr'
import { SWRConfiguration } from 'swr/_internal'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import useUser from 'shared/hooks/use-user'
import { MEMBERSHIP_API } from 'modules/school/api/membership-api'
import { LightLectureInterface } from '../types/light-lecture-interface'

export interface UseDigitalCourseLectureOptions {
  lectureId: string
  config?: SWRConfiguration<LightLectureInterface, Error>
}

const getLightViewLectureKey = (lectureId: string) =>
  `${MEMBERSHIP_API}/light-editor/lecture/${lectureId}`

export function useLightViewLecture({ config, lectureId }: UseDigitalCourseLectureOptions) {
  const { user } = useUser()
  const { fetcher } = useApiWrapperWithErrorValidation<
    RequestMethodsEnum.get,
    LightLectureInterface
  >({
    method: RequestMethodsEnum.get,
    badRequestHandler: () => {},
    notFoundResponseHandler: () => {},
  })

  return useSWR<LightLectureInterface>(
    () => {
      if (user) {
        return getLightViewLectureKey(lectureId)
      }
      return null
    },
    fetcher,
    config,
  )
}
